import React from 'react'
import "./styles.css";
import signup_success from "common/assets/images/signup_success.png";
import password_reset from "common/assets/images/password_reset.png";

export interface AuthSuccessResetPasswordInterface {
    handleOnPageSwitch:(key:string)=>void;
    successType:string;
}

const AuthSuccessResetPassword = (props:AuthSuccessResetPasswordInterface) => {

    const {handleOnPageSwitch,successType} = props;

    const signUpSuccessText = {
        title: "Account Created Successfully",
        content:
          "You can now login with your credentials from the login page by clicking the below button.",
        type: "signup",
      };
    const resetSuccessText = {
        title: "Password Reset Successful",
        content:
            "You can login with your new password from the login page by clicking the below button.",
        type: "reset",
        };



  return (
    <React.Fragment>
        <div id="sign-in-screen">
            <div id="success-acknowledge-screen-ad">
                <span id="success-acknowledge-screen-header-icon-ad">
                    {successType == "reset" ? (<img src={password_reset} />) : (<img src={signup_success} />)}
                </span>
                <span id="success-acknowledge-screen-title-ad">{successType == "reset" ? resetSuccessText.title:signUpSuccessText.title}</span>
                <br />

                <span id="success-acknowledge-screen-body-content-ad">{successType == "reset" ? resetSuccessText.content:signUpSuccessText.content}</span>
                <span id="create-account-button-ad" onClick={() => {handleOnPageSwitch('LOGIN')}} style={successType == "reset" ? { border: "1px solid #67833E" } : {}} >
                    Go To Login Page
                </span>
            </div>
           
        </div>
    </React.Fragment>
  )
}

export default AuthSuccessResetPassword